import { createI18n, type LocaleMessages, type VueMessageType } from 'vue-i18n'

export function loadLocaleMessages(): { [x: string]: LocaleMessages<VueMessageType> } {
  const locales: any = import.meta.glob('./locales/**', { eager: true })
  let messages: LocaleMessages<VueMessageType> = {}
  Object.keys(locales).forEach((key: string) => {
    const matched = key.match(/([a-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      // const locale = matched[1]
      messages = { ...messages, ...locales[key]['de'] }
    }
  })
  return { de: messages }
}

const t_i18n = createI18n({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  globalInjection: true,
  // messages,
  messages: loadLocaleMessages(),
  dateTimeFormats: {
    'de-DE': {
      short: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
    }
  },
  numberFormats: {
    'de-DE': {
      currency: {
        style: 'currency',
        currency: 'EUR',
        currencyDisplay: 'code'
      }
    }
  }
})

export default t_i18n

export const t = t_i18n.global.t
export const n = t_i18n.global.n
